export default __webpack_public_path__ + "static/attest_overview-c8b1e95774c6800761c3190fbb0dc836.png";